//-----------------------------------------------------------------------------
// economy
//-----------------------------------------------------------------------------

import { Tier } from './interfaces';

export enum Currency {
	SILVER = 'silver',
	GOLD = 'gold',
}

export interface Wallet {
	userId: string;
	silver: number;
	gold: number;
	silverRefill: Date | null;
	goldRefill: Date | null;
	updatedAt: Date;
}

export interface RefillPolicy {
	tier: number;
	silverRefill: number;
	silverEraHours: number;
	goldRefill: number;
	goldEraHours: number;
}

// constants used to fine-tune the economy
// even though some of these are forge-only or studio-only, we'll keep them here
// so everything can be managed in one place

export const WALLET_INITIAL_VALUES: Record<Currency, number> = {
	[Currency.SILVER]: 8000,
	[Currency.GOLD]: 3500,
};

export const LOW_THRESHOLD = 1500;

export const REFILL_POLICIES: Record<number, RefillPolicy> = {
	0: {
		tier: 0,
		silverRefill: 2000,
		silverEraHours: 16,
		goldRefill: 1000,
		goldEraHours: 120,
	},
	1: {
		tier: 1,
		silverRefill: 10000,
		silverEraHours: 16,
		goldRefill: 7500,
		goldEraHours: 120,
	},
	2: {
		tier: 2,
		silverRefill: 15000,
		silverEraHours: 16,
		goldRefill: 10000,
		goldEraHours: 16,
	},
};

// Amount of gold user is given when they opt to refill manually
export const GOLD_REFILL_AMOUNTS: Record<Tier, number> = {
	[Tier.FREE]: 2000,
	[Tier.TIER_1]: 5000,
	[Tier.TIER_2]: 10000, // TIER_2 users should have unlimited gold, but putting this here just in case for completeness
};

// Maximum number of bonus refills a user can perform
export const MAX_BONUS_REFILLS = 2;
